import React from 'react'

const ProfileView = (props) => {
    return (
        <div className='profile-card-container'>
            {props.children}
        </div>
    )
}

export default ProfileView